"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function connect(HOC, dependencies, mergeProps, passedComponent) {
  var component = passedComponent;
  var props = mergeProps;

  if (arguments.length === 3) {
    component = props;
    props = null;
  }

  return HOC(dependencies, props, component);
}

exports.default = function (HOC) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return connect.apply(undefined, [HOC].concat(args));
  };
};

var decoratorFactory = exports.decoratorFactory = function decoratorFactory(HOC) {
  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return function (component) {
      return connect.apply(undefined, [HOC].concat(args, [component]));
    };
  };
};
//# sourceMappingURL=connect.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@cerebral/react/lib/connect.js
// module id = 259
// module chunks = 0